import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

/**
 * Shopify-style setup card for product Home pages.
 */
const HomeSetupCard = ({
  title,
  description,
  cta,
  href,
  icon: Icon,
  done = false,
  badge = null,
}) => {
  return (
    <div className="flex h-full flex-col overflow-hidden rounded-lg border border-border bg-surface">
      <div className="relative flex h-28 items-center justify-center bg-surface-muted sm:h-32">
        {done ? (
          <div className="absolute right-3 top-3 inline-flex h-6 items-center gap-1 rounded-md bg-ink px-2 text-[11px] font-medium text-white">
            <Check className="h-3 w-3" />
            Done
          </div>
        ) : null}
        {badge && !done ? (
          <div className="absolute right-3 top-3 rounded-md border border-border bg-surface px-2 py-0.5 text-[11px] font-medium text-ink">
            {badge}
          </div>
        ) : null}
        <div className="flex h-12 w-12 items-center justify-center rounded-md bg-surface text-ink shadow-sm">
          {Icon ? <Icon className="h-5 w-5" /> : null}
        </div>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="text-sm font-semibold text-ink">{title}</h3>
        <p className="mt-1.5 flex-1 text-xs leading-relaxed text-ink-secondary">
          {description}
        </p>
        {href && cta ? (
          <Link
            to={href}
            className="mt-4 inline-flex h-8 min-h-8 w-fit items-center rounded-md border border-border bg-surface px-3 text-xs font-medium text-ink transition-colors hover:bg-surface-muted"
          >
            {cta}
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default HomeSetupCard;
